import { useGetCompanyDomainsQuery } from '../../../../../../api/integrations'

export const useDomainManagement = () => {
  const { data: domains, isLoading } = useGetCompanyDomainsQuery()

  return {
    domains,
    isAddingDomain: isLoading
  }
}
